import * as redux from 'redux'
import * as Request from '../../request'
import * as Colors from './color-picker'
import * as Constants from './constants'
import * as Counts from './counts'
import * as EmailTemplate from './email-template'
import * as Logo from './logo'
import * as SocialMedia from './social-media'
import * as Types from './types'

type ConfigState = Types.Config

const emptyStringArray: string[] = []
const initialConfigState = {
  isEditing: false,
  isFetching: true,
  isUpdating: false,
  partnerCodes: emptyStringArray,
  selectedPartner: '',
}

type Actions = redux.Action & Request.SuccessAction & Types.SelectPartnerAction

const configStateReducer = (state: ConfigState = initialConfigState, action: Actions) => {
  switch (action.type) {
    case Request.successConstant(Constants.FETCH_COMMUNITY_CONFIG):
      return {
        ...state,
        isEditing: false,
        isFetching: false,
        selectedPartner: '',
      }
    case Request.requestConstant(Constants.FETCH_COMMUNITY_CONFIG):
      return {
        ...state,
        isFetching: true,
      }
    case Constants.SELECT_PARTNER_CODE:
      return {
        ...state,
        selectedPartner: action.partner,
      }
    case Colors.UPDATE_SYNTHETIC_COLOR_KEY:
    case Colors.DELETE_COLOR:
    case EmailTemplate.UPDATE_EMAIL_TEMPLATE:
    case EmailTemplate.ADD_EMAIL_TEMPLATE:
    case Counts.ADD_NEWSBRIEF_COUNT:
    case Counts.UPDATE_NEWSBRIEF_COUNT:
    case SocialMedia.DELETE_ICON:
    case SocialMedia.UPDATE_SOCIAL_MEDIA_DROPDOWN:
    case SocialMedia.UPDATE_URL_FIELD:
    case Logo.ADD_HEADER_LINK_URL:
    case Logo.UPDATE_HEADER_LINK_URL:
    case Request.successConstant(Logo.LOGO_IMPORT):
      return {
        ...state,
        isEditing: true,
      }
    case Request.requestConstant(Constants.UPDATE_OR_CREATE_CONFIG):
      return {
        ...state,
        isUpdating: true,
      }
    case Request.successConstant(Constants.UPDATE_OR_CREATE_CONFIG):
      return {
        ...state,
        isEditing: false,
        isUpdating: false,
      }
    default:
      return state
  }
}

export const reducer = redux.combineReducers({
  colors: Colors.reducer,
  configState: configStateReducer,
  counts: Counts.reducer,
  emailTemplate: EmailTemplate.reducer,
  logo: Logo.reducer,
  socialMedia: SocialMedia.reducer,
})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/reducer.ts